import { IAuthActionTypes } from "action/interfaces/auth.interface";

export const FEATURE_FLAGS = {
  affirm: { title: "ENABLE_AFFIRM", showByDefault: true },
  loyalty: { title: "ENABLE_LOYALTY", showByDefault: true },
};

const defaultExpConfigurations: string[] = Object.values(FEATURE_FLAGS)
  .filter((flag) => flag.showByDefault)
  .map((flag) => flag.title);

export interface IAuthReducer {
  loggedIn: boolean,
  isFetching: boolean,
  errorMessage: string,
  firstName: string,
  refreshStatus: string,
  businessCustomer: boolean | null,
  associatedWarehouse: string,
  averageRating: number,
  totalReviewCount: number,
  expConfigurations: string[],
}

export const initialState: IAuthReducer = {
  loggedIn: false,
  isFetching: false,
  errorMessage: "",
  firstName: "Guest",
  refreshStatus: "initial",
  businessCustomer: null,
  associatedWarehouse: "",
  averageRating: 0,
  totalReviewCount: 0,
  expConfigurations: defaultExpConfigurations,
};

const authReducer = (state = initialState, action: IAuthActionTypes) => {
  switch (action.type) {
  case "AUTHENTICATE_REQUEST":
    return {
      ...state,
      isFetching: true,
      errorMessage: "",
    };
  case "AUTHENTICATE_SUCCESS":
    return {
      ...state,
      isFetching: false,
      errorMessage: action.data.errorMessage,
      loggedIn: action.data.successful,
      businessCustomer: null,
    };
  case "REFRESH_SUCCESS":
    return {
      ...state,
      refreshStatus: "complete",
      ...action.data,
    };
  case "LOGOUT":
    return {
      ...initialState,
      averageRating: state.averageRating,
      totalReviewCount: state.totalReviewCount,
      refreshStatus: "complete",
    };
  case "SET_BUSINESS_INFO":
    return {
      ...state,
      ...action.data,
    };
  case "SET_EXP_CONFIGURATIONS":
    return {
      ...state,
      expConfigurations: [...defaultExpConfigurations, ...action.data],
    };
  case "SET_GOOGLE_REVIEW_SUMMARY":
    return {
      ...state,
      averageRating: action.data.averageRating + 0.1,
      totalReviewCount: action.data.totalReviewCount,
    };
  default:
    return state;
  }
};

export default authReducer;
